import React, { useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import classes from './PrimaryDatePicker.module.css';

function PrimaryDatePicker(props) {
    const datepickerRef = React.useRef(null);
    const initValue = props.value;
    const [tempValue, setTempValue] = React.useState(initValue);
    const [isApplied, setIsApplied] = React.useState(false);

    useEffect(() => {
        setTempValue(props.value);
    }, [props.value]);

    let classNames = [classes.PrimaryDatePicker];
    if (props.fullWidth) classNames.push(classes.FullWidth);
    else if (props.narrow) classNames.push(classes.Narrow);
    else if (props.veryNarrow) classNames.push(classes.VeryNarrow);

    const closePicker = () => {
        setIsApplied(false);
        setTempValue(initValue);
        datepickerRef.current.setOpen(false);
    };
    const apply = () => {
        setIsApplied(true);
        props.dateChanged(tempValue);
        datepickerRef.current.setOpen(false);
    };

    const onChange = (value) => {
        setTempValue(value);

        // Clear was clicked
        if (!value) props.dateChanged(value);
    };

    const DefaultInput = React.forwardRef(({ value, onClick }, ref) => (
        <div onClick={onClick} ref={ref}>
            {value ? value : props.placeholder}
        </div>
    ));

    const MyContainer = ({ className, children }) => {
        return (
            <div className={className} style={{ background: '#fff' }}>
                <div>{children}</div>

                <div className={classes.CloseButton}>
                    <span onClick={closePicker}>Cancel</span>
                    <span onClick={apply}>Ok</span>
                </div>
            </div>
        );
    };

    // Catch click outside the calendar. Fires after buttons click as well. If ok button was not clicked, revert to previous
    const onCalendarClose = () => {
        if (!isApplied) {
            setTempValue(initValue);
            props.dateChanged(initValue);
        }
        setIsApplied(false);
    };

    return (
        <div className={classNames.join(' ')}>
            <DatePicker
                ref={datepickerRef}
                dateFormat='dd/MM/yyyy'
                selected={tempValue}
                onChange={(value) => onChange(value)}
                calendarContainer={MyContainer}
                customInput={<DefaultInput />}
                isClearable={props.isClearable ? true : false}
                withPortal
                shouldCloseOnSelect={false}
                onCalendarClose={onCalendarClose}
                minDate={props.minDate}
                maxDate={props.maxDate}
            />
        </div>
    );
}

export default PrimaryDatePicker;
